var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolygon = function SvgPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.28 14.074 4.745-2.74a.816.816 0 0 0 .407-.704V5.15c0-.29-.156-.56-.407-.705l-4.744-2.74a.816.816 0 0 0-.814 0l-4.744 2.74a.816.816 0 0 0-.407.705v9.79l-3.327 1.92-3.327-1.92V11.1L5.99 9.18l2.194 1.267V7.87L6.396 6.838a.82.82 0 0 0-.814 0L.84 9.577a.816.816 0 0 0-.407.705v5.479c0 .29.155.559.407.704l4.743 2.74a.82.82 0 0 0 .814 0l4.744-2.74a.816.816 0 0 0 .407-.704V5.969l.06-.034 3.266-1.886L18.2 5.97V9.81l-3.327 1.92-2.192-1.264v2.577l1.785 1.03a.82.82 0 0 0 .813 0h.002Z"
  })));
};
export default SvgPolygon;